/**
 * <DockBody />
 *
 * @parent anybody
 * @children
 * @stateless
 */
import React, { PropTypes } from 'react';
import { Dock } from 'components/UI';
import { confirmable } from 'react-confirm';
import Loading from 'components/UI/Loading';
import Transition from 'components/UI/Transition';
import { Provider, connect } from 'react-redux'
import _ from 'lodash';
import store from 'root/store';
import VerticalInfoGrid from 'components/UI/VerticalInfoGrid';
import ContactHeader from './ContactHeader';
import ContactNotes from './ContactNotes/index';
import locale from './locale';
import __R from 'containers/__R'
import {fetchContactInfo} from './redux/actions/fetchContactInfo'
import moment from 'moment'
import PotentialClientModal from 'template/Modals/PotentialClient'
import getClientCustomFields from 'controllers/client/getClientCustomFields'
import {
	Tab,
	Tabs,
	TabList,
	TabPanel,
} from 'components/UI'

import './style.scss';

const GENDERS = [__('Male', locale), __('Female', locale), __('Others', locale), __('N/A', locale)];

const mapStateToProps = (state) => ({
  user: state.user,
  contactInfo: state.contactInfo,
})

const mapDispatchToProps = (dispatch) => {
	return {
    fetchContactInfo: (contactId, callback) => dispatch(fetchContactInfo(contactId, callback)),
	};
};


class DockBody extends React.Component {
  static propTypes = {

  }

  constructor(props) {
    super(props);

    this.state = {
			selectedIndex: 0,
      contact: props.contactData,
      fields: [],
      fetching: false,
    }

		this.onSelectTab = this.onSelectTab.bind(this)
		this.onClickEdit = this.onClickEdit.bind(this)
  }

	componentDidMount(){
		const {id} = this.props

    this.props.fetchContactInfo(id, () => {
      this.setState({contact: this.props.contactInfo})
    })
    this.getCustomFields();
	}

	onSelectTab(selectedIndex){
		this.setState({selectedIndex})
	}

	onClickEdit() {
		const { contact } = this.state;

    PotentialClientModal({clientId: contact.id, type: 'edit'})
		.then(() => {
			this.props.fetchContactInfo(this.props.id, () => {
				this.setState({contact: this.props.contactInfo})
			})
		})
	}
  getCustomFields() {
    const schoolId = localStorage.getItem('schoolId');
    getClientCustomFields(schoolId)
    .then(({ contact_custom_fields })=>{

      const { fields = [] } = contact_custom_fields;

      this.setState({
        fields,
      });
    })
    .catch((err)=>{
      console.error(err);
    });
  }
  render() {
		const {isVisible, show, dismiss, mode, id, name, proceed} = this.props;
    const {fetching, contact, fields, selectedIndex} = this.state;

    let basicInfo = [];
    let otherInfo = [];
    
    if (contact) {
      basicInfo = [
        { label: __('Name', locale), value: contact.first_name + ' ' + contact.last_name, },
        { label: __('Gender', locale), value: __(GENDERS[contact.gender], locale) },
			  { label: __('Date of Birth', locale), value: contact.birthday },
			  { label: __('Phone No.', locale), value: contact.mobile },
			  { label: __('Email', locale), value: contact.email },
			  { label: __('Guardian Email', locale), value: contact.guardian_email },
			  { label: __('Guardian Phone No.', locale), value: contact.guardian_mobile },
			  { label: __('Guardian Name', locale), value: contact.guardian_name },
			  { label: __('Tag', locale), value: contact.tag_name_list.join(', ') },
        { label: __('Created At', locale), value: moment(contact.created_at).format('YYYY-MM-DD hh:mm A') },
        { label: __('Remarks', locale), value: contact.remark },
      ];
      fields.map((field)=>{
        const {
          label,
          id,
          type,
        } = field;
  
        if (contact.custom_data) {
          let value = contact.custom_data[id];
  
          if (type === 'checkbox') {
            try {
              let arrayValue = JSON.parse(value);
              value = arrayValue.toString();
            } catch (e) {
  
            }
          }
  
          if (label) {
            otherInfo.push({ label, value });
          }
        }
      });
    }

		if(!contact){
			return(
				<div/>
			)
		}

    return (
      <Provider store={store}>
        <Dock
          dockStyle={{ minWidth: 760, maxWidth: 880 }}
          className='contactInfoDock'
          position='right'
          isVisible={show}
          size={0.62}
          overlayOpacity={0.2}
          onCloseDockClick={()=>{
            proceed();
          }}
          useClosingTag={true}
          dockTitle={
            <ContactHeader contact={contact} onClickEdit={this.onClickEdit} />
          }
          useDefaultCloseButton={false}
        >
          { fetching && <Loading /> }
          { !fetching &&
            <Transition>
              <Tabs defaultIndex={selectedIndex} onSelect={this.onSelectTab}>
                <TabList>
                  <Tab>{__("Info", locale)}</Tab>
                  <Tab>
										{__("Notes", locale)}
									</Tab>
                </TabList>

                <TabPanel>
                  <div className='studentDetail'>
                    <h3>{__('Basic Info', locale)}</h3>
                    <VerticalInfoGrid data={basicInfo} />
                    <h3>{__('Other Info', locale)}</h3>
                    <VerticalInfoGrid data={otherInfo} />
                  </div>
                </TabPanel>

                <TabPanel>
									<ContactNotes contactId={contact.id} />
                </TabPanel>

	            </Tabs>
	          </Transition>
					}
        </Dock>
      </Provider>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(confirmable(DockBody));



// WEBPACK FOOTER //
// ./src/template/Docks/ContactInfo/DockBody.js